export const SET_USER = 'SET_USER';
export const INIT_DATA = 'INIT_DATA';
export const SET_AUTH = 'SET_AUTH';
export const SET_SHARE_POST = 'SET_SHARE_POST';
